import React from "react";
import CasesPage from "../pages/cases";
import { Route, Routes } from "react-router-dom";
import Homepage from "../pages/home/Homepage";
const DynamicRoutes = ({ appRoutes, setAppRoutes }) => {
  return (
    <Routes>
      <Route path="/" element={<Homepage setAppRoutes={setAppRoutes} />} />
      {<Route path={"/cases"} element={<CasesPage />} />}
    </Routes>
  );
};

export default DynamicRoutes;
